import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import React, { useEffect, useContext, useState } from "react";
import "./CardTurnoKin.css";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import { PortalContext } from "../../../context/Provider";

const CardTurnoKin = ({
  idTurno,
  medico,
  centro,
  ubicacion,
  hora,
  fecha,
  handleOnClickConfirmar,
  especialidad,
  infoSesion,
  nroOrden,
  nroSesion,
  handleOnClickVerTurnos,
}) => {
  const { modalDispatch } = useContext(PortalContext);
  const boxCardEspecialidad = "ptur-cardTurnoKin-boxEsp";
  const btnEspecialidad = "ptur-cardTurnoKin-boxBtnEspecialidad";
  const medEspecialidad = "ptur-cardTurnosKin-box-bodyMedEsp";

  const [turnoData, setTurnoData] = useState({
    idTurno: idTurno,
    medico: medico,
    centro: centro,
    ubicacion: ubicacion,
    hora: hora,
    fecha: fecha,
    especialidad: especialidad,
  });

  return (
    <React.Fragment>
      {nroOrden === 1 ? (
        <div
          className={`ptur-cardTurnoKin-box ${
            especialidad !== "" ? boxCardEspecialidad : ""
          }`}
        >
          <div className="ptur-cardTurnosKin-box-body">
            <p
              className={`ptur-cardTurnosKin-box-bodyMed ${
                especialidad !== "" ? medEspecialidad : ""
              } rb18b`}
            >
              {infoSesion}
            </p>
            <div className="ptur-cardTurnosKin-box-bodyInfo">
              {/* <p className="ptur-cardTurnosKin-box-bodyEsp rb16l">{especialidad}</p> */}

              <p className="ptur-cardTurnosKin-box-bodyCentro rb16xl">
                {centro}
              </p>
              <p className="ptur-cardTurnosKin-box-bodyUbi c-latex30 rb12tl">
                {ubicacion}
              </p>
              <div className="ptur-cardTurnosKin-box-bodyCentro">
                <div className="ptur-cardTurnosKin-infoTurno">
                  <p className="rb16xl">Primer Turno:</p>
                  <p className="rb16xl">
                    {getDiaStrTurno(fecha, false, true)}
                    {getDiaStrTurno(fecha, true, true)}
                    <span className="ptur-cardTurnosKin-box-bodyHora rb16t">{`${hora}hs`}</span>
                  </p>
                </div>
                <div
                  className={`ptur-cardTurnoKin-boxBtn ${
                    especialidad !== "" ? btnEspecialidad : ""
                  }`}
                >
                  <button
                    id={nroSesion}
                    onClick={handleOnClickVerTurnos}
                    className="ptur-cardTurnoKin-btn2 bgc-white c-latex30 rb16m"
                  >
                    Ver turnos + horarios
                  </button>
                  <button
                    id={idTurno}
                    onClick={handleOnClickConfirmar}
                    className="ptur-cardTurnoKin-btn bgc-primary c-white rb18m"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};
export default CardTurnoKin;
